import {Slider} from "@/components/ui/slider.tsx";
import {Label} from "@/components/ui/label.tsx";

interface SliderProps {
    label: string,
    value: number,
    valueLabel?: string,
    min?: number,
    max?: number,
    step?: number,
    onChange: (value: number) => void
}

export default function LabeledSlider({label, value, valueLabel, min, max, step, onChange}: SliderProps) {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
                <Label>{label}</Label>
                <span className="text-muted-foreground">{valueLabel ? valueLabel : value}</span>
            </div>
            <Slider
                value={[value]}
                max={max}
                min={min}
                step={step}
                onValueChange={(value) => onChange(value[0])}
            />
        </div>

    )
}